import { defineComponent, ref, markRaw } from 'vue'
import { useRouter } from 'vue-router'
import DashboardView from '../dashboard/dashboard-view.vue'
import ManageView from '../manage/manage-view.vue'
import UsersView from '../users/users-view.vue'
import BackgroundView from '../background/background-view.vue'
import TombstoneView from '../tombstone/tombstone-view.vue'
import CoupletView from '../couplet/couplet-view.vue'
import HallsView from '../halls/halls-view.vue'
import ProductsView from '../products/products-view.vue'
import LegalView from '../legal/legal-view.vue'
import HeritageView from '../heritage/heritage-view.vue'
import HeritageCategoryView from '../heritage-category/heritage-category-view.vue'
import CommentTemplateView from '../comment-template/comment-template-view.vue'
import RecommendHallsView from '../recommend-halls/recommend-halls-view.vue'
import RecommendPersonsView from '../recommend-persons/recommend-persons-view.vue'
import PlatformContactView from '../platform-contact/platform-contact-view.vue'
import CreateManagementView from '../create-management/create-management-view.vue'

export default defineComponent({
  name: 'HomePageView',
  components: {
    DashboardView,
    ManageView,
    UsersView,
    BackgroundView,
    TombstoneView,
    CoupletView,
    HallsView,
    ProductsView,
    LegalView,
    HeritageView,
    HeritageCategoryView,
    CommentTemplateView,
    RecommendHallsView,
    RecommendPersonsView,
    PlatformContactView,
    CreateManagementView
  },
  setup() {
    const router = useRouter()
    const activeMenu = ref('dashboard')
    const currentView = ref(markRaw(DashboardView))

    const handleLogout = () => {
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      router.push('/login')
    }

    const switchMenu = (menu) => {
      activeMenu.value = menu
      switch (menu) {
        case 'dashboard':
          currentView.value = markRaw(DashboardView)
          break
        case 'manage':
          currentView.value = markRaw(ManageView)
          break
        case 'users':
          currentView.value = markRaw(UsersView)
          break
        case 'createManagement':
          currentView.value = markRaw(CreateManagementView)
          break
        case 'background':
          currentView.value = markRaw(BackgroundView)
          break
        case 'tombstone':
          currentView.value = markRaw(TombstoneView)
          break
        case 'couplet':
          currentView.value = markRaw(CoupletView)
          break
        case 'halls':
          currentView.value = markRaw(HallsView)
          break
        case 'recommendHalls':
          currentView.value = markRaw(RecommendHallsView)
          break
        case 'recommendPersons':
          currentView.value = markRaw(RecommendPersonsView)
          break
        case 'products':
          currentView.value = markRaw(ProductsView)
          break
        case 'heritage':
          currentView.value = markRaw(HeritageView)
          break
        case 'heritageCategory':
          currentView.value = markRaw(HeritageCategoryView)
          break
        case 'commentTemplate':
          currentView.value = markRaw(CommentTemplateView)
          break
        case 'legal':
          currentView.value = markRaw(LegalView)
          break
        case 'platformContact':
          currentView.value = markRaw(PlatformContactView)
          break
      }
    }

    return {
      activeMenu,
      currentView,
      handleLogout,
      switchMenu
    }
  }
}) 
